import {
  IMGIX_PRODUCT_IMAGE_HEIGHT,
  IMGIX_PRODUCT_IMAGE_WIDTH,
} from '~shared/modules/product-card/constants/image.constants';

import { IMGIX_BASE_URL, IMGIX_IMAGE_FORMATE, IMGIX_IMAGE_QUALITY } from '~shared/constants/imgix.constant';

export namespace ProductCardImageUtil {
  // Expected parameters:
  // 1. https://storage.googleapis.com/imgix-source-nonprod/
  // 175b66c8-c345-416d-8a35-ea560229e6a4_148?h=148&w=148&q=70&auto=format&fit=max
  // 2. https://prod-metro-markets.imgix.net/item_image/
  // 175b66c8-c345-416d-8a35-ea560229e6a4_148?h=148&w=148&q=70&auto=format&fit=max
  // 3. https://storage.googleapis.com/imgix-source-nonprod/
  // 175b66c8-c345-416d-8a35-ea560229e6a4_148
  // 4. https://prod-metro-markets.imgix.net/item_image/
  // 175b66c8-c345-416d-8a35-ea560229e6a4_148
  // 5. 175b66c8-c345-416d-8a35-ea560229e6a4_148

  export function getSourceSet(productImage: string, crop?: boolean): string {
    const isValidImageUrl = productImage != null;
    if (!isValidImageUrl) {
      return productImage;
    }

    const isUrl = productImage.includes('/');
    if (isUrl && !IMGIX_BASE_URL()) {
      return `${productImage} 1x`;
    }

    const baseUrl = getSourceSetBaseUrl(productImage, crop);
    return `${baseUrl} 1x, ${baseUrl}&dpr=2 2x, ${baseUrl}&dpr=3 3x`;
  }

  function getSourceSetBaseUrl(productImage: string, crop?: boolean): string {
    const imageId = getImageIdFromUrl(productImage);
    return (
      `${IMGIX_BASE_URL()}/item_image/${imageId}` +
      `?h=${IMGIX_PRODUCT_IMAGE_HEIGHT}&w=${IMGIX_PRODUCT_IMAGE_WIDTH}&q=${IMGIX_IMAGE_QUALITY}` +
      `&${IMGIX_IMAGE_FORMATE}=format&fit=${crop ? 'crop' : 'max'}`
    );
  }

  function getImageIdFromUrl(productImage: string): string {
    // Example urls
    // 1. https://storage.googleapis.com/imgix-source-nonprod/
    // 175b66c8-c345-416d-8a35-ea560229e6a4_148?h=148&w=148&q=70&auto=format&fit=max
    // 2. https://storage.googleapis.com/imgix-source-nonprod/
    // 175b66c8-c345-416d-8a35-ea560229e6a4_148

    // we might got the id only like: 175b66c8-c345-416d-8a35-ea560229e6a4_148
    if (!productImage.includes('/')) {
      return productImage;
    }

    const imageUrlParts = productImage.split('/');
    // 175b66c8-c345-416d-8a35-ea560229e6a4_148
    // OR
    // 175b66c8-c345-416d-8a35-ea560229e6a4_148?h=148&w=148&q=70&auto=format&fit=max
    const lastUrlPart = imageUrlParts[imageUrlParts.length - 1];

    if (!lastUrlPart.includes('?')) {
      return lastUrlPart;
    }

    const imageUrlWithQueryParamsParts = lastUrlPart.split('?');
    return imageUrlWithQueryParamsParts[0];
  }
}
